import { CONSENT_DOCUMENT_VERSIONS } from '../consent-policy';
import { LEGAL_DOCUMENT_SLUGS } from './types';
/**
 * HUKUKİ BELGE KAYDI — hangi metin var, hangi rızaya karşılık geliyor.
 *
 * `version` alanı BURADA YOK ve bu bilinçlidir: sürüm `CONSENT_DOCUMENT_VERSIONS`
 * içinde zaten yaşıyor ve veritabanına o değerle yazılıyor. İkinci bir yere
 * kopyalansaydı ikisi ayrışırdı ve kullanıcının onayladığı sürüm ile okuduğu
 * sürüm sessizce farklılaşırdı. `versionOf()` tek okuma noktasıdır.
 */
export const LEGAL_DOCUMENTS = {
    /*
     * KAPALI SAĞLAYICILAR (kısıtlı canlı, kullanıcı kararı 16.10.2026): Sentry
     * (hata takibi) ve PostHog (kullanım analitiği) kısıtlı canlıda kapalı
     * olduğu için hukuki metinlerden çıkarıldı. `SENTRY_DSN`,
     * `NEXT_PUBLIC_SENTRY_DSN`, `NEXT_PUBLIC_POSTHOG_KEY`, `MOBILE_SENTRY_DSN`
     * ya da `MOBILE_POSTHOG_KEY` canlıda doldurulmadan ÖNCE şu metinlere geri yazılır: KVKK aydınlatma metninin aktarım tablosu (iki
     * dil, Ülke sütunuyla; `legal-transfer-country.guard.spec`), gizlilik
     * politikasının hizmet sağlayıcılar paragrafı, PostHog için açık rıza
     * metninin analitik bölümü. Metin değişince sürüm kuralı
     * `consent-policy.ts`teki gibidir.
     */
    'kvkk-aydinlatma': {
        slug: 'kvkk-aydinlatma',
        consentType: 'kvkk_clarification',
        effectiveDate: '2026-11-02',
    },
    'gizlilik-politikasi': {
        slug: 'gizlilik-politikasi',
        consentType: 'privacy_policy',
        effectiveDate: '2026-11-02',
    },
    'kullanim-kosullari': {
        slug: 'kullanim-kosullari',
        consentType: 'terms_of_service',
        effectiveDate: '2026-11-02',
    },
    'acik-riza': {
        slug: 'acik-riza',
        // Açık rıza metni TEK bir rıza türüne bağlanamaz: pazarlama ve analitik
        // rızalarının ORTAK metnidir. Bağı `consentType` değil `OPEN_CONSENT_TYPES`
        // kurar. 02.11.2026: analitik bölümü değiştiği için analitik rızasıyla
        // birlikte ilerledi; pazarlama bölümü değişmedi (`consent-policy.ts`).
        consentType: null,
        effectiveDate: '2026-11-02',
    },
    'cerez-politikasi': {
        slug: 'cerez-politikasi',
        // Bilgilendirmedir: listelenen çerezlerin tamamı zorunludur ve rıza
        // gerektirmez (çerez bandı 08.09.2026'da kaldırıldı). Analitik rızası
        // `analytics` türü üzerinden Ayarlar › Rızalarım'dan alınır; metnin
        // tercih-yönetimi bölümü 17.09.2026'da anahtarın bugünkü kapsamına
        // göre yeniden yazıldı, yürürlük o gün ilerledi.
        consentType: null,
        effectiveDate: '2026-09-17',
    },
    'satis-basvurusu': {
        slug: 'satis-basvurusu',
        // Aydınlatmadır, rıza konusu DEĞİLDİR: formdaki kutu "okudum" beyanıdır.
        // Sürüm kendi yürürlük günüdür ve satış başvurusu kaydına o değerle
        // yazılır (`sales_inquiries.notice_version`). Avukat onaylı metin gelince
        // tarih ilerler, eski sürümle gelen form 400 alır (Story B1).
        consentType: null,
        effectiveDate: '2026-10-01',
    },
    'kurum-hesabi-aydinlatma': {
        slug: 'kurum-hesabi-aydinlatma',
        // Kurum hesabının rıza setindeki bilgilendirme (V11): kurum davetiyle
        // açılan hesap bu metnin yürürlükteki sürümünü deftere yazar. Kişisel
        // hesabın KVKK aydınlatma metninin yerini kurum hesabında bu metin alır.
        consentType: 'organization_account_notice',
        effectiveDate: '2026-10-03',
    },
};
/**
 * Açık rıza metninin kapsadığı rıza türleri (isteğe bağlı olanların tamamı).
 * `attendee_visibility` 09.10.2026'da çıktı: tür EMEKLİDİR
 * (`RETIRED_CONSENT_TYPES`), katılımcı listesinin dayanağı rıza değil
 * sözleşmenin ifasıdır (kırmızı çizgi 2).
 */
export const OPEN_CONSENT_TYPES = ['marketing_email', 'analytics'];
/**
 * Metnin ekranda gösterilecek sürümü.
 *
 * Kendi rıza türü olan metin, deftere yazılan sürümü gösterir. Rıza konusu
 * OLMAYAN metin (çerez politikası, açık rıza metni) kendi yürürlük tarihini
 * gösterir: bir belgenin sürümü onun yürürlük günüdür, başka bir belgenin
 * sürümü değil. Eski hâli ikisini gizlilik politikasına bağlıyordu; gizlilik
 * politikası 17.09'da ilerleyince değişmemiş çerez politikası "Sürüm 17.09 ·
 * Yürürlük 8 Eylül" gösterdi (QA, Story 8). Açık rıza metninin kapsadığı
 * türlerle bağı `consent-policy.guard.spec` ölçer.
 */
export function versionOf(slug) {
    const { consentType, effectiveDate } = LEGAL_DOCUMENTS[slug];
    return consentType === null ? effectiveDate : CONSENT_DOCUMENT_VERSIONS[consentType];
}
/**
 * METİN YÜZEYLERİ — belge OLMAYAN hukuki sayfalar. Bunlar birer metin değil,
 * birer AKIŞTIR; şablonu paylaşmazlar ve ayrı tasarlanmışlardır.
 *
 * `hesap-silme` yayın için kritiktir: Google Play 2023'ten beri hesap silmenin
 * HERKESE AÇIK bir adresten, uygulamayı indirmeden anlatılmasını şart koşuyor.
 * Bu sayfa kimlik duvarının ARKASINA alınırsa mağaza kaydı reddedilir.
 */
export const LEGAL_SURFACE_SLUGS = ['kvkk-basvuru', 'hesap-silme'];
/** Oturum açmadan erişilebilir OLMASI GEREKEN yollar. */
export const PUBLIC_LEGAL_SLUGS = [
    ...LEGAL_DOCUMENT_SLUGS,
    'hesap-silme',
];
/** Alt bilgide görünecek sıra — ekranda elle sıralanmaz, buradan okunur. */
export const LEGAL_FOOTER_ORDER = [
    'kvkk-aydinlatma',
    'gizlilik-politikasi',
    'kullanim-kosullari',
    'cerez-politikasi',
    'hesap-silme',
];
/**
 * KİMLİK EKRANLARININ DİBİNDEKİ YASAL SATIR (kullanıcı kararı 08.09.2026 —
 * ortalanmış giriş kompozisyonu). Alt bilginin tam listesini TEKRARLAMAZ:
 * hesap açarken bağlayıcı olan iki metin gösterilir, kalanı zaten sayfanın alt
 * bilgisinde durur.
 *
 * Sıra `LEGAL_FOOTER_ORDER`den SÜZÜLÜR, ikinci bir dizi olarak yazılmaz: kayda
 * yeni metin girer ya da sıra değişirse tek yerde değişir ve iki yüzey
 * ayrışmaz. Süzgeç boşalırsa kapı (`auth-screen-inventory`) kırılır.
 */
export const AUTH_LEGAL_ORDER = LEGAL_FOOTER_ORDER.filter((slug) => slug === 'kullanim-kosullari' || slug === 'gizlilik-politikasi');
//# sourceMappingURL=registry.js.map